module.exports = __webpack_public_path__ + "f21cf5e8e6773d3dffd873abd7129891.png";